// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeletePaymentRuleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for delete_payment_rule /payroll/delete_payment_rule
 * Returns success flag indicating whether the payment rule was deleted
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeletePaymentRuleResponseDados = boolean;

export type Payroll_DeletePaymentRuleResponse = ApiResponse<Payroll_DeletePaymentRuleResponseDados>;

registerResponseContract('Payroll_DeletePaymentRuleResponse', {})
